import { enGB, enCA, enUS, frCA, es, de, nl } from 'date-fns/locale';

// See https://date-fns.org/v2.12.0/docs/format
// Based on https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L27
export const DATE_FNS_FORMAT_STR_REGEX = /^['GyYRuQqMLwIdDeEicabBhHkmsXSxOztPp]/;

// See https://date-fns.org/docs/I18n
const LocaleMap = {
  'en': enUS,
  'en-US': enUS,
  'en-CA': enCA,
  'fr-CA': frCA,
  'es-AR': es,
  'en-GB': enGB,
  'de-DE': de,
  'de-AT': de,
  'en-IE': enGB,
  'nl-NL': nl,
};

// Need to keep track of the current dateFN locale that is synced with i18n
let DATE_FNS_LOCALE: keyof typeof LocaleMap = 'en';

export function getDateFNLocale(): Locale {
  return LocaleMap[DATE_FNS_LOCALE];
}

/**
 * Converts a locale string to one of the locales we currently support in dateFn.
 * Will fallback to `en` if unable to map the locale
 */
export function lookupDateFNLocale(locale?: string): Locale {
  if (!locale) {
    return LocaleMap['en'];
  } else if (LocaleMap[locale as keyof typeof LocaleMap]) {
    return LocaleMap[locale as keyof typeof LocaleMap];
  } else {
    console.error(`Unable to find the date-fns locale from '${locale}'`);

    return LocaleMap['en'];
  }
}

export function setDateFNLocale(locale?: string): Locale {
  const dateDnLocale = lookupDateFNLocale(locale);
  DATE_FNS_LOCALE = dateDnLocale.code as keyof typeof LocaleMap;

  return dateDnLocale;
}

